import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Modal,
  Switch,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";

import CloseIcon from "@mui/icons-material/Close";
import { ModalHeader } from "../../common/modalHeader";
import { getAllCustomerDetail } from "../../common/searchModal/api";
import { addWhatAppGroup } from "./customerGroupingApi";

import { swalAlertPopProps } from "../../utils/commonUtils";
import Swal from "sweetalert2";
import { validationOnKey } from "./addGroupValidation";
const data = {
  categoryName: "",
  items: [],
};

export default function AddCategories({
  selectedCategories,
  section,
  selectedItems,
  setSelectedItems,
  callback,
  open,
  addCategoriesData,
  updateCategoriesData,
  setOpen,
}) {
  const [itemData, setItemData] = useState(data);
  const [allItems, setAllItems] = useState([]);

  const onClose = () => {
    // setItemData(data);
    setOpen(false);
    // setSelectedItems([]);
  };

  useEffect(() => {}, [allItems, selectedCategories]);

  useEffect(() => {
    if (open) {
    } else {
      setItemData({ categoryName: "" });
    }
  }, [open]);
  useEffect(() => {
    getAllCustomerDetail(
      {
        page: 1,
        pageSize: 1000,
        filter: "",
        search: "",
        filter2: "",
        search2: "",
      },
      (data) => {
        setAllItems(data);
        console.log("data detail ", data);
      }
    );
  }, []);
  useEffect(() => {
    // if (selectedCategories) {
    //   setItemData({ ...itemData, ...selectedCategories });
    // }
  }, [selectedCategories]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Grid
        container
        sx={{
          // backgroundColor: "white",
          // width:"40%"
          background: "white",
          width: { xs: "70%", sm: "30%" },
          borderRadius: "10px",
          position: "absolute",
          left: {xs:"15%", sm:"35%", md:"38%"},
          top: "30%",
        }}
      >
        <Grid item xs={12}>
          <ModalHeader
            title={"Customer Group"}
            onClose={(data) => {
              setOpen(data);
            }}
          />
          {/* <DialogTitle color="primary"></DialogTitle> */}

          <Box sx={{ p: 1 }}>
            <Box sx={{ mt: 2, paddingX: "1rem" }}>
              <TextField
                fullWidth
                size="small"
                variant="outlined"
                value={itemData.categoryName}
                onChange={(e) => {
                  setItemData({ ...itemData, categoryName: e.target.value });
                }}
                label={"Customer Group Name"}
                InputProps={{
                  // readOnly: true,

                  sx: {
                    background: "#fff",
                    borderRadius: 1,
                    cursor: "pointer",
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: 500,
                  },
                }}
                InputLabelProps={{
                  sx: {
                    background: "#fff",
                    borderRadius: 1,
                    cursor: "pointer",
                    fontFamily: "'Montserrat', sans-serif",
                    fontSize: { xs: "12px", sm: "13px", md: "15px" },
                    fontWeight: 500,
                  },
                }}
              />
              {/* <FormControl sx={{ width: "100%" }} component="fieldset">
            {allItems
               
              ?.map((item2, index) => {
                return (
                  <FormGroup
                    sx={{ width: "100%" }}
                    aria-label="position"
                    row
                    key={"notAssigntable" + index}
                  >
                    <FormControlLabel
                      sx={{
                        width: "100%",
                        justifyContent: "space-between",
                        px: 2,
                        m: 0,
                      }}
                      control={
                        <Checkbox
                           
                          onChange={(e) => {
                            
                          
                          }}
                        />
                      }
                      label={item2?.name}
                      labelPlacement="start"
                    />
                  </FormGroup>
                );
              })}
          </FormControl> */}
            </Box>
          </Box>
          {/* <Divider /> */}
          <Box
            sx={{ display: "flex", justifyContent: "center", padding: "10px" }}
          >
            {/* <Button onClick={onClose}>Cancel</Button> */}
            <Button
              sx={{ width: "50%" }}
              variant="contained"
              onClick={() => {
                // if()
                let isValid = validationOnKey({ ...itemData });
                if (!isValid.status) {
                  Swal.fire({
                    text: isValid.text,
                    icon: "warning",
                    ...swalAlertPopProps,
                  });
                } else {
                  addWhatAppGroup(
                    {
                      customerGroupName: itemData?.categoryName,
                    },
                    () => {
                      // getAllCustomerDetail(
                      //   {
                      //     page: 1,
                      //     pageSize: 1000,
                      //     filter: "",
                      //     search: "",
                      //     filter2: "",
                      //     search2: ""
                      //   }, (data) => {
                      //     setAllItems(data)
                      //     console.log("data detail ", data)
                      //   })
                    }
                  );
                }

                setOpen(false);
                setTimeout(() => {
                  callback();
                }, 500);
              }}
            >
              Save
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Modal>
  );
}
